import React from "react";
import Container from "../../../shared/Container";
import Section from "../../../shared/Section";
import P from "../../../shared/typography/P";
import CloseButton from "../../../shared/ui/CloseButton";
import Info from "../../../shared/ui/Info";
import FollowUpCard from "./FollowUpCard";

const ViewFollowUp = ({ onClick, data }) => {
    return (
        <Section className=" bg-white mb-0 ">
            <div className="min-h-[128px] bg-blue-700 lg:hidden"></div>
            <div className="pt-2 rounded-3 bg-white -mt-3 lg:mt-0 pb-12">
                <Container>
                    <CloseButton onClick={onClick} className="lg:hidden" />
                    <div>
                        <P className="bg-gray-100 text-center text-sm py-0.8 rounded-sm mb-2 font-vietnam hidden lg:block ">
                            Follow-up
                        </P>
                        {data?.followups?.length ? (
                            data?.followups.map((item, index) => (
                                <FollowUpCard {...item} key={index} />
                            ))
                        ) : (
                            <Info message="No Followups available" />
                        )}
                    </div>

                    <P className="bg-gray-60 text-center text-sm py-0.8 rounded-sm mb-2 font-vietnam ">
                        Meeting Notes
                    </P>

                    <div>
                        {data?.meetingNotes?.length ? (
                            data?.meetingNotes.map((noteObj, index) => (
                                <React.Fragment key={index}>
                                    {Object.keys(noteObj).map((note, idx) => (
                                        <div
                                            key={idx}
                                            className="flex justify-between items-center py-1.5 px-1 border-b border-blue-200"
                                        >
                                            <P className="text-xs font-vietnam font-light">
                                                {note}
                                            </P>
                                            <P className="text-xs font-vietnam font-light">
                                                {typeof noteObj[note] ===
                                                "boolean"
                                                    ? noteObj[note] === true
                                                        ? "Yes"
                                                        : "No"
                                                    : noteObj[note]}
                                            </P>
                                        </div>
                                    ))}
                                </React.Fragment>
                            ))
                        ) : (
                            <Info message="No Notes available" />
                        )}
                    </div>
                </Container>
            </div>
        </Section>
    );
};

export default ViewFollowUp;
